<template>
  <div>
    <div
      class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix"
      style="margin-top:0px"
    >
      <div class="app-list-sort header-item-fix">
        <!-- <b-dropdown>
              <template v-slot:button-content>
                <sort-icon />
              </template>
              <b-dropdown-item
                v-for="(item, index) in sortList"
                :kedark="index"
                @click="listSort(item)"
                :key="index"
              >
                <span class="pull-left" v-if="pageParams.orderBy == item.value">
                  <i
                    v-if="pageParams.sort == 'desc'"
                    class="bx bx-down-arrow-alt font-size-18 pull-left"
                  ></i>
                  <i
                    v-if="pageParams.sort == 'asc'"
                    class="bx bx-up-arrow-alt font-size-18"
                  ></i>
                </span>
                <span :class="{ padleft: pageParams.orderBy != item.value }">{{
                  item.text
                }}</span>
              </b-dropdown-item>
            </b-dropdown> -->
      </div>

      <div class="header-item-fix">
        <b-form-input
          size="sm"
          type="text"
          v-model="pageParams.content"
          placeholder="ID、话题名称"
          @keyup.enter.native="search"
          style="width: 110px; margin-left: 10px"
        ></b-form-input>
        <b-button size="sm" variant="primary" @click="search()">
          <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
          搜索
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="resetParams()">
          <i class="bx bx-revision font-size-16 align-middle"></i>
          重置
        </b-button>
      </div>

      <div class="header-item-fix">
        <b-form-select
          style="width: 100px"
          @change="search()"
          v-model="pageParams.showState"
          class="form-select"
          :options="statusList"
          type="text"
        ></b-form-select>
      </div>

      <b-button
        size="sm"
        v-if="power['添加']"
        variant="primary"
        @click="toCreate()"
      >
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        添加
      </b-button>
    </div>
    <div>
      <el-table
        v-loading="tableLoading"
        :data="items"
        style="width: 100%"
        :stripe="true"
        @selection-change="tableSelectionChange"
        row-key="id"
        ref="elTable"
      >
        <el-table-column
          style="padding-left: 1rem"
          fixed="left"
          type="selection"
          align="center"
        >
        </el-table-column>
        <el-table-column label="ID" prop="id" width="90"> </el-table-column>
        <el-table-column label="话题名称" min-width="200" prop="title">
        </el-table-column>
        <el-table-column label="封面" width="120">
          <template slot-scope="item">
            <img
              v-if="item.row.image"
              class="w-16-9-rem"
              :src="`${item.row.image}`"
              alt
            />
            <img
              v-if="!item.row.image"
              class="w-16-9-rem"
              src="@/assets/images/default_cover_16_9.png"
              alt=""
            />
          </template>
        </el-table-column>
        <el-table-column label="关联题主用户" width="110">
          <template slot-scope="item">
            {{ item.row.nickName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="阅读数" width="80">
          <template slot-scope="item">
            {{ item.row.viewNum + item.row.operateViewNum || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="讨论数" width="80">
          <template slot-scope="item">
            {{ item.row.commentNum + item.row.operateCommentNum || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="item">
            <el-tooltip
              v-if="power['显示/隐藏']"
              :content="item.row.showState == 1 ? '点击隐藏' : '点击显示'"
            >
              <span
                @click="batchHide(item.row)"
                v-if="item.row.showState == 1"
                class="dsply-fix status-open"
                ><i></i>显示</span
              >
              <span
                @click="batchShow(item.row)"
                v-if="item.row.showState == 0"
                class="dsply-fix status-off"
                ><i></i>隐藏</span
              >
            </el-tooltip>
            <div v-if="!power['显示/隐藏']">
              <span v-if="item.row.showState == 1" class="dsply-fix status-open"
                ><i></i>显示</span
              >
              <span v-if="item.row.showState == 0" class="dsply-fix status-off"
                ><i></i>隐藏</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="170">
          <template slot-scope="item">
            <span>{{ item.row.createdAt }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="190">
          <template slot-scope="item">
            <div style="display: flex; flex-wrap: wrap">
              <div style="padding: 5px 0">
                <button
                  v-if="power['编辑']"
                  type="button"
                  class="btn-sm btn btn-primary m-r-10"
                  @click="toDetail(item.row)"
                >
                  编辑
                </button>
              </div>
              <div style="padding: 5px 0">
                <button
                  v-if="power['内容管理']"
                  type="button"
                  class="btn-sm btn btn-primary m-r-10"
                  @click="toContent(item.row)"
                >
                  内容管理
                </button>
              </div>
              <!-- <div style="padding: 5px 0">
                <button
                  v-if="power['评论']"
                  type="button"
                  class="btn-sm btn btn-primary m-r-10"
                  @click="toComment(item.row)"
                >
                  评论
                </button>
              </div> -->
              <div style="padding: 5px 0">
                <button
                  v-if="power['移除']"
                  type="button"
                  class="btn-sm btn btn-danger"
                  @click="deleteBatch(item.row)"
                >
                  删除
                </button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      class="bath_r_20"
      :total="pageTotal"
      :batchs="batchs"
      :pageSize="pageParams.pageSize"
      :page.sync="pageParams.page"
      :pageSizes="[30, 50, 100]"
      @pageCallback="pageCallback"
    ></pagination>
    <topic-detail ref="detail" @change="getList(false)"></topic-detail>
  </div>
</template>

<script>
import TopicDetail from "./Detail.vue";
import { list, deleteItems, state as changeState } from "@/server/api/topic.js";
import { changeList } from "@/util/fun.js";
import { addCache, updateCache } from "@/util/localAche.js";
export default {
  components: { TopicDetail },
  data() {
    return {
      items: [],
      power: [],
      pageTotal: 0,
      tableLoading: false,
      selectedData: [],
      pageParams: {
        page: 1,
        pageSize: 30,
        type: "",
        showState: "",
        /*sortBy: "",
        order: "",*/
        content: "",
      },
      statusList: [
        { text: "筛选状态", value: "" },
        { text: "显示", value: "1" },
        { text: "隐藏", value: "0" },
      ],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "显示", value: "show" },
        { text: "隐藏", value: "hide" },
        { text: "移除", value: "remove" },
      ],
    };
  },
  methods: {
    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.showState = "";
      this.pageParams.content = "";
      this.getList();
    },
    search() {
      this.getList(1);
    },
    getList(page) {
      if (typeof page == "number") {
        this.pageParams.page = 1;
      }
      if (page !== false) {
        this.tableLoading = true;
      }
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      list(params).then((res) => {
        console.log("列表", res);
        if (res.code === 0) {
          this.tableLoading = false;
          if (res.data.items) {
            this.items = res.data.items;
          }
          this.pageTotal = res.data.total;
        } else {
          this.warning(res.msg);
        }
      });
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        if (this.selectedData.length == 0) {
          this.warning("未选择内容");
          return;
        }
        console.log(obj);
        if (obj.batch == "hide") {
          this.changeState(0, 0);
        } else if (obj.batch == "show") {
          this.changeState(0, 1);
        } else if (obj.batch == "remove") {
          this.deleteBatch();
        }
        // if (this.choiceListIds.length < 1) {
        //   this.warning("请选择内容");
        //   return;
        // }
        // this.deleteItem();
      }
    },
    toCreate() {
      this.$refs.detail.showModel();
    },
    tableSelectionChange(selectValues) {
      this.selectedData = selectValues;
    },
    batchHide(item) {
      this.changeState(item, 0);
    },
    batchShow(item) {
      this.changeState(item, 1);
    },
    changeState(item, state) {
      let msg = state == 1 ? "确认显示？" : "确认隐藏？";
      this.confirm(msg, () => {
        let params = { ids: [] };
        if (item) {
          params.ids.push({
            id: item.id,
            showState: state,
          });
        } else {
          this.selectedData.forEach((tr) => {
            params.ids.push({
              id: tr.id,
              showState: state,
            });
          });
        }
        console.log("保存参数", params);
        // let stateApi = state == 1 ? article.show : article.hide;
        changeState(params.ids).then((res) => {
          if (res.code === 0) {
            this.success("更改成功");
            // this.getList(); 修改状态后不调用列表接口，直接改数据
            this.items = changeList(
              "changeAttribute",
              this.items,
              item ? [item.id] : params.ids.map((tr) => tr.id),
              {
                showState: state == 1 ? 1 : 0,
              }
            );
            if (!item) {
              this.selectedData = [];
            }
          } else {
            this.warning(res.msg);
          }
        });
      });
    },
    toDetail(item) {
      this.$refs.detail.showModel(item);
    },
    deleteBatch(item) {
      this.confirm("确认删除？", () => {
        let params = { ids: [] };
        if (item) {
          params.ids.push(item.id);
        } else {
          this.selectedData.forEach((tr) => {
            params.ids.push(tr.id);
          });
        }
        deleteItems(params).then((res) => {
          if (res.code === 0) {
            this.success("删除成功");
            // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
            if (this.items.length == params.ids.length) {
              this.getList();
            } else {
              this.pageTotal -= params.ids.length;
              this.items = changeList("delete", this.items, params.ids, "id");
            }
            this.selectedData = [];
          } else {
            this.warning(res.msg);
          }
        });
      });
    },
    toContent(item) {
      this.$router.push({
        path: "topicContent",
        query: {
          topicId: item.id,
          userId: item.userId,
        },
      });
    },
    toComment() {},
  },
  created() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    this.power = this.utils.currentPower("话题-列表");
    this.batchs = [];
    if (this.power["显示/隐藏"] || this.power["移除"]) {
      this.batchs.push({ text: "批量操作", value: "0" });
    }
    if (this.power["显示/隐藏"]) {
      this.batchs.push(
        { text: "显示", value: "show" },
        { text: "隐藏", value: "hide" }
      );
    }
    if (this.power["移除"]) {
      this.batchs.push({ text: "移除", value: "remove" });
    }
    let obj = this.getCache("topicManage-list");
    if (obj && obj.list && obj.list[0]) {
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      this.pageParams = obj.pageParams;
    } else {
      this.getList();
    }
  },
  beforeDestroy() {
    this.addCache("topicManage-list", {
      list: this.items,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },
  beforeRouteEnter(to, from, next) {
    if (["/topicContent", "/topicComment"].indexOf(from.path) == -1) {
      updateCache("topicManage-list", { list: "" });
      addCache("");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (["/topicContent"].indexOf(to.path) == -1) {
      updateCache("topicManage-list", { list: "" });
      addCache("");
    }
    next();
  },
};
</script>

<style></style>
